<template>
  <div class="login" id="login">
    <h1>Login</h1>
    <input :disabled="loggingIn" type="text" v-model="email"> <br><br>
    <input :disabled="loggingIn" type="password" v-model="password"><br><br>
    <button :disabled="loggingIn" @click="login">Login</button>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: localStorage.getItem('email') || '',
      password: localStorage.getItem('password') || '',
      loggingIn: false
    }
  },
  methods: {
    login() {
      this.loggingIn = true;

      this.axios.post(this.config.api + '/login', { email: this.email, password: this.password })
        .then(result => {
          this.loggingIn = false;

          if (!result.data.token) throw new Error('incorrect login information');
          else {
            localStorage.setItem('email', this.email);
            localStorage.setItem('password', this.password);
            localStorage.setItem('token', result.data.token);

            this.$router.push('/');
          }
        })
        .catch(error => {
          this.loggingIn = false;

          alert(error)
        })
    }
  }
}
</script>

<style scoped>

.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
}

h1 {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue